export default "__VITE_ASSET__rD3C5qqF__"